import { useEffect } from 'react';

const updateMeta = (attr, content, isProperty = false) => {
  const selector = isProperty
    ? `meta[property="${attr}"]`
    : `meta[name="${attr}"]`;
  let el = document.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    isProperty
      ? el.setAttribute('property', attr)
      : el.setAttribute('name', attr);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

const setCanonicalLink = (url) => {
  let link = document.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', url);
};

const useSeo = ({
  title,
  description,
  keywords,
  ogTitle,
  ogDescription,
  ogImage = '/favicon.ico',
  ogUrl,
}) => {
  useEffect(() => {
    if (title) document.title = title;
    if (description) updateMeta('description', description);
    if (keywords) updateMeta('keywords', keywords);
    updateMeta('robots', 'index, follow');

    if (ogTitle) updateMeta('og:title', ogTitle, true);
    if (ogDescription) updateMeta('og:description', ogDescription, true);
    if (ogImage) updateMeta('og:image', ogImage, true);
    if (ogUrl) {
      updateMeta('og:url', ogUrl, true);
      setCanonicalLink(ogUrl);
    }
  }, [title, description, keywords, ogTitle, ogDescription, ogImage, ogUrl]);
};

export default useSeo;
